export default __webpack_public_path__ + "static/media/Pointed Pommelin.1c741caa.png";